import { createSlice } from '@reduxjs/toolkit'

import { LocalJournalingProgress } from '../types'

const initialState = {
  localJournalingProgressData: [] as LocalJournalingProgress[],
}

const LocalJournalingSlice = createSlice({
  name: 'LocalJournalingSlice',
  initialState,
  reducers: {
    updateLocalJournalingProgress: (state, action) => {
      state.localJournalingProgressData = action.payload
    },
    clearAllJournalingProgress: (state) => {
      state.localJournalingProgressData = initialState.localJournalingProgressData
    },
  },
})

const LocalJournalingReducer = LocalJournalingSlice.reducer
export const { updateLocalJournalingProgress, clearAllJournalingProgress } =
  LocalJournalingSlice.actions

export default LocalJournalingReducer
